<nav class="navbar navbar-light navbar-expand">
  <button
    class="btn-toggle-menu"
    type="button"
    (click)="toggleSidebarClick()"
    aria-label="Toggle menu"
    [class.is-open]="!isSidebarMini"
  >
    <i class="fas fa-bars"></i>
  </button>

  <ul class="nav navbar-nav ml-auto">
    <li *ngIf="hasChatAccess && !isOnChatPage" class="nav-item nav-item-chat">
      <button
        class="nav-chat-button"
        type="button"
        (click)="toggleChat()"
        sgtTooltip="Fale com a Aya"
        tooltipPosition="bottom"
      >
        <i class="far fa-comment"></i>
      </button>
    </li>
    <li class="nav-item dropdown">
      <sgt-notification-menu></sgt-notification-menu>
    </li>
    <li class="nav-item dropdown ml-3">
      <sgt-account-menu></sgt-account-menu>
    </li>
  </ul>
</nav>
